import React from 'react';

export const AGB = () => {
  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-page)'
    }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 className="display-medium" style={{ marginBottom: 'var(--spacing-xl)' }}>
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            1. Geltungsbereich
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen dem Anbieter und Kunden über digitale Inhalte und Dienstleistungen, die über diese Website angeboten werden. Dies umfasst Online-Kurse, Abonnement-Programme, Beratungs- und Coaching-Leistungen, Personal Training sowie digitale Produkte.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            2. Anbieter
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die vollständigen Angaben zum Anbieter entnehmen Sie bitte dem Impressum dieser Website.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            3. Vertragsgegenstand
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Der Anbieter bietet folgende Leistungen an:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: 'var(--spacing-medium)' }}>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Online-Kurse und digitale Programme (z.B. Haltung-Reset-Programm)
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Abonnement-Programme mit monatlicher Zahlung
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Individuelle Online-Beratung und Coaching-Leistungen
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Personal Training (online und vor Ort)
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Digitale Produkte wie PDF-Guides und Video-Lektionen
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            4. Vertragsschluss
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Der Vertrag kommt durch den Abschluss des Online-Zahlungsvorgangs (z.B. über PayPal oder Kreditkarte) zustande. Nach erfolgreicher Zahlung erhält der Kunde eine Bestätigungsmail mit den Zugangsdaten bzw. weiteren Informationen zur gebuchten Leistung.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            5. Preise und Zahlungsbedingungen
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Alle angegebenen Preise verstehen sich in Euro und beinhalten die gesetzliche Mehrwertsteuer. Die Zahlung erfolgt im Voraus. Bei Abonnement-Programmen erfolgt eine automatische monatliche Abbuchung für die vereinbarte Laufzeit. Nach bereits erbrachter Leistung besteht, sofern gesetzlich zulässig, kein Anspruch auf Rückerstattung.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            6. Leistungsumfang
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Der Zugang zu digitalen Inhalten erfolgt unmittelbar nach Zahlungseingang. Bei Coaching-, Beratungs- und Personal-Training-Leistungen erfolgt die Leistungserbringung zu den individuell vereinbarten Terminen. Der Anbieter schuldet eine Dienstleistung nach bestem Wissen und Gewissen. Ein bestimmter Erfolg oder gesundheitlicher Fortschritt kann nicht garantiert werden.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            7. Termine, Stornierung und Ausfall
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Vereinbarte Termine für Beratung, Coaching oder Personal Training sind verbindlich. Stornierungen müssen mindestens 24 Stunden vor dem vereinbarten Termin per E-Mail erfolgen. Bei kurzfristiger Absage oder Nichterscheinen des Kunden ohne rechtzeitige Stornierung kann die Leistung als erbracht gelten und ein Anspruch auf Erstattung oder Nachholung entfällt.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            8. Widerrufsrecht
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Die genauen Bedingungen und Ausnahmen entnehmen Sie bitte der gesonderten Widerrufsbelehrung. Insbesondere erlischt das Widerrufsrecht bei digitalen Inhalten, wenn der Kunde ausdrücklich zustimmt, dass mit der Ausführung vor Ablauf der Widerrufsfrist begonnen wird, und seine Kenntnis vom Erlöschen des Widerrufsrechts bestätigt.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            9. Haftung
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Der Anbieter haftet nur bei Vorsatz und grober Fahrlässigkeit. Eine Haftung für gesundheitliche Schäden, die durch Missachtung von Anweisungen oder eigenverantwortliches Handeln des Kunden entstehen, ist ausgeschlossen. Die Teilnahme an Programmen und Trainingseinheiten erfolgt auf eigene Verantwortung. Bei gesundheitlichen Beschwerden oder Vorerkrankungen sollte vor Beginn ein Arzt konsultiert werden.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            10. Urheberrecht
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Alle Inhalte, Videos, Texte, Bilder und Materialien sind urheberrechtlich geschützt. Eine Weitergabe, Vervielfältigung, Verbreitung oder Nutzung außerhalb des persönlichen Gebrauchs ist ohne ausdrückliche Zustimmung des Anbieters untersagt und kann rechtliche Konsequenzen nach sich ziehen.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            11. Kündigung und Laufzeit
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Bei Abonnement-Programmen mit monatlicher Zahlung kann der Vertrag mit einer Frist von einem Monat zum Ende der jeweiligen Abrechnungsperiode gekündigt werden, sofern keine andere Laufzeit vereinbart wurde. Die Kündigung erfolgt per E-Mail an die im Impressum angegebene Adresse.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            12. Schlussbestimmungen
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen hiervon unberührt.
          </p>
        </section>

        <p className="body-medium" style={{ fontStyle: 'italic', color: 'var(--text-light)' }}>
          Stand: Januar 2025
        </p>
      </div>
    </div>
  );
};
